import { IIntake, IIntakeIncomeForm } from '../../shared';

export const intakeIncomeToFormMapper = (intake: IIntake): IIntakeIncomeForm => {
    return {
        income: intake.income?.sort((a, b) => a.incomeTypeName.localeCompare(b.incomeTypeName)) || [],
    };
};
